export default defineNuxtPlugin((nuxtApp) => {
  nuxtApp.vueApp.directive('click-outside', {
    beforeMount(el: any, binding: DirectiveBinding) {
      el.clickOutsideEvent = (event: Event) => {
        if (!(el === event.target || el.contains(event.target as Node))) {
          if (typeof binding.value === 'function') {
            binding.value(event);
          }
        }
      };
      document.addEventListener('click', el.clickOutsideEvent);
    },
    unmounted(el: any) {
      document.removeEventListener('click', el.clickOutsideEvent);
    },
  });
});
